import { finalize } from "rxjs/operators";
import { ChangeDetectionStrategy, Component, signal } from "@angular/core";
import { FormGroup, FormControl } from '@angular/forms';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TranslateService } from "@ngx-translate/core";
import { DialogService } from "primeng/dynamicdialog";
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from "@medsurf/flat-validators";
import { ModalControlComponent } from "@medsurf/flat-components";

@Component({
    selector: 'medsurf-common-custom-enumeration',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './custom-enumeration.component.html',
    styleUrls: ['./custom-enumeration.component.scss'],
    standalone: false
})
export class CustomEnumerationComponent {
  #isSubmitted = signal(false);
  node: FlatModels.NodeEntityModels.NodeEntityType | null;
  generateCustomEnumerationTypeForm = new FormGroup(
    {
      type: new FormControl(FlatModels.QuestionEntityModels.NumberingType.NUMBER),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.QuestionEntityModels.generateCustomEnumerationTypeSchema
      ),
      updateOn: 'change',
    }
  );
  readonly FlatModels = FlatModels;
  
  constructor(private trainingSharedFacade: FlatFacades.TrainingSharedFacade,
              private nodeSharedFacade: FlatFacades.NodeSharedFacade,
              private alertControlFacade: FlatFacades.AlertControlFacade,
              private dialogService: DialogService,
              private translate: TranslateService,) {
    this.nodeSharedFacade.currentSelectedNode$.pipe(takeUntilDestroyed()).subscribe((node) => {
      this.node = structuredClone(node);
      this.#isSubmitted.set(false);
    });
  }
  
  onSubmit() {
    if (this.#isSubmitted() || this.generateCustomEnumerationTypeForm.invalid || !this.node) {
      return;
    }
    this.#isSubmitted.set(true);
    
    const dialogRef = this.dialogService.open(ModalControlComponent, {
      header: this.translate.instant('global.custom_enumeration_generate'),
      data: {
        label: 'global.custom_enumeration_generate_confirm',
        inputLabel: 'global.custom_enumeration_generate_label',
        inputClass: FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER
      },
      dismissableMask: true,
      width: '50%'
    });
    dialogRef.onClose.subscribe(confirm => {
      if (this.node && confirm) {
        const type = this.generateCustomEnumerationTypeForm.value.type || FlatModels.QuestionEntityModels.NumberingType.NUMBER;
        this.trainingSharedFacade.requestGenerateCustomEnumeration(type, this.node.children).pipe(
          finalize(() => this.#isSubmitted.set(false))
        ).subscribe({
          error: (result) => {
            ZodSharedValidator.handleError(result, this.alertControlFacade, this.generateCustomEnumerationTypeForm);
          },
        });
      } else {
        this.#isSubmitted.set(false);
      }
    });
  }
}
